import React, { useContext } from 'react';
import Layout from '../components/Layout';
import { FaQrcode } from 'react-icons/fa';
import AppContext from '../api/AppContext';

const CarteirinhaQRCode = () => {
  const { user } = useContext(AppContext);
  const dadosAssociado = user?.dadosAssociado;
  
  // Estilos estão definidos no final do arquivo
  const styles = getStyles();
  
  // Dados para a carteirinha
  const nomeAssociado = dadosAssociado?.NOME || dadosAssociado?.titular?.nome || user?.name || 'Nome não disponível';
  const cpfAssociado = dadosAssociado?.CPF || dadosAssociado?.titular?.cpf || user?.cpf || '';
  const numeroTitulo = dadosAssociado?.numero || dadosAssociado?.TITULO || user?.numeroTitulo || '';
  const digito = dadosAssociado?.DIGITO ? dadosAssociado.DIGITO.trim() : '0';
  const tag = dadosAssociado?.TAG ? dadosAssociado.TAG : '0';
  console.log(tag)
  // URL para QR Code (usando CPF ou número do título)
  const qrData = tag || 'olympic-club';
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${qrData}`;

  // Foto do associado (se disponível em base64)
  const fotoAssociado = dadosAssociado?.titular?.foto;

  return (
    <Layout title="Carteirinha" icon={FaQrcode}>
      <div style={styles.cardContainer}>
        <div style={styles.card}>
          {/* Cabeçalho */}
          <div style={styles.header}>
            <h2 style={styles.title}>Carteirinha de Associado</h2>
            <p style={styles.subtitle}>Olympic Club Barbacena</p>
          </div>
          
          {/* Corpo */}
          <div style={styles.body}>
            {/* Seção do QR Code */}
            <div style={styles.qrSection}>
              <img 
                src={qrCodeUrl} 
                alt="QR Code" 
                style={styles.qrCode}
              />
              <p style={styles.qrText}>Apresente o QR Code para validação</p>
            </div>
            
            {/* Seção de informações */}
            <div style={styles.infoSection}>
              <div style={styles.photoInfoContainer}>
                {/* Foto do associado */}
                <div style={styles.photoSpace}>
                  {fotoAssociado ? (
                    <img 
                      src={`data:image/jpeg;base64,${fotoAssociado}`} 
                      alt="Foto do associado" 
                      style={styles.photo}
                    />
                  ) : (
                    <div style={styles.photoPlaceholder}>Foto</div>
                  )}
                </div>
                
                {/* Informações */}
                <div style={styles.infoContainer}>
                  <div style={styles.infoRow}>
                    <span style={styles.label}>Nome:</span>
                    <span style={styles.value}>{nomeAssociado}</span>
                  </div>
                  
                  <div style={styles.infoRow}>
                    <span style={styles.label}>Título:</span>
                    <span style={styles.value}>{numeroTitulo}-{digito}</span>
                  </div>
                  
                  <div style={styles.infoRow}>
                    <span style={styles.label}>CPF:</span>
                    <span style={styles.value}>
                      {cpfAssociado ? cpfAssociado.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : 'Não informado'}
                    </span>
                  </div>

                  <div style={styles.infoRow}>
                    <span style={styles.label}>Status:</span>
                    <span style={styles.value}>
                      {dadosAssociado?.adimplente ? 'Adimplente' : 'Inadimplente'}
                    </span>
                  </div>

                  <div style={styles.infoRow}>
                    <span style={styles.label}>Validade:</span>
                    <span style={styles.value}>12/2024</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Rodapé */}
          <div style={styles.footer}>
            <p style={styles.footerText}>
              {dadosAssociado?.ATIVO?.trim() === 'S' 
                ? 'Carteirinha válida - Associado ativo' 
                : 'Carteirinha inativa - Entre em contato com o clube'}
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

// Estilos inline definidos como uma função que retorna um objeto
const getStyles = () => ({
  cardContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    fontFamily: '"Arial", sans-serif',
  },
  card: {
    width: '100%',
    maxWidth: '400px',
    backgroundColor: '#fff',
    borderRadius: '15px',
    boxShadow: '0 10px 20px rgba(51, 51, 51, 0.3)',
    overflow: 'hidden',
    border: '1px solid #e0e0e0',
    fontFamily: '"Montserrat", sans-serif',
  },
  header: {
    backgroundColor: '#2c3e50',
    color: '#fff',
    padding: '15px 20px',
    textAlign: 'center',
  },
  title: {
    margin: 0,
    fontSize: '1.4rem',
    fontWeight: '500',
  },
  subtitle: {
    margin: '5px 0 0 0',
    fontSize: '0.9rem',
    opacity: 0.8,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
  },
  qrSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    backgroundColor: '#f9f9f9',
    borderRadius: '10px',
    marginBottom: '20px',
  },
  qrCode: {
    width: '150px',
    height: '150px',
  },
  qrText: {
    margin: '10px 0 0 0',
    fontSize: '0.8rem',
    color: '#666',
    textAlign: 'center',
  },
  infoSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  photoInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '15px',
  },
  photoSpace: {
    width: '85px',
    height: '117px',
    backgroundColor: '#f5f5f5',
    border: '1px dashed #ccc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5px',
    overflow: 'hidden',
  },
  photo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  photoPlaceholder: {
    color: '#999',
    fontSize: '12px',
  },
  infoContainer: {
    flex: 1,
  },
  infoRow: {
    marginBottom: '12px',
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontWeight: 'bold',
    color: '#2c3e50',
    fontSize: '0.8rem',
    marginBottom: '2px',
  },
  value: {
    color: '#333',
    wordBreak: 'break-word',
    fontSize: '0.9rem',
  },
  footer: {
    backgroundColor: '#ecf0f1',
    padding: '10px 20px',
    textAlign: 'center',
    borderTop: '1px solid #e0e0e0',
  },
  footerText: {
    margin: 0,
    color: '#7f8c8d',
    fontSize: '0.8rem',
    fontWeight: '500',
  },
});

export default CarteirinhaQRCode;